import {
  faBars,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@/components/shared/IconButton';
import { useTranslator } from '@/hooks/useTranslator';
import { useSidebarStore } from '@/store/sidebarStore';
import { Breadcrumbs } from './Breadcrumbs';
import type { BreadcrumbsProps } from './types';

/**
 * The header's left side: the mobile sidebar toggle, history back/forward, and
 * the breadcrumb trail. Every area navigates, so this is shared whole rather
 * than assembled piece by piece.
 */
export function AppHeaderNav({
  breadcrumb,
  breadcrumbTrail,
}: BreadcrumbsProps) {
  const setMobileOpen = useSidebarStore(s => s.setMobileOpen);
  const { getTranslation } = useTranslator({ page: 'appHeader' });

  return (
    <>
      <IconButton
        variant='ghost'
        size='icon'
        className='md:hidden h-7.5 w-7.5 text-muted-foreground mr-1'
        tooltip={getTranslation('openMenu')}
        onClick={() => setMobileOpen(true)}
      >
        <FontAwesomeIcon icon={faBars} className='text-sm' />
      </IconButton>
      <div className='hidden sm:flex items-center gap-1'>
        <IconButton
          variant='ghost'
          size='icon'
          className='h-6.5 w-6.5'
          tooltip={getTranslation('back')}
          onClick={() => history.back()}
        >
          <FontAwesomeIcon icon={faChevronLeft} className='text-xs' />
        </IconButton>
        <IconButton
          variant='ghost'
          size='icon'
          className='h-6.5 w-6.5'
          tooltip={getTranslation('forward')}
          onClick={() => history.forward()}
        >
          <FontAwesomeIcon icon={faChevronRight} className='text-xs' />
        </IconButton>
      </div>

      <div className='hidden md:flex min-w-0'>
        <Breadcrumbs
          breadcrumb={breadcrumb}
          breadcrumbTrail={breadcrumbTrail}
        />
      </div>
    </>
  );
}
